
import React from 'react';

const Monitor = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M25 5H7C5.35 5 4 6.35 4 8v13c0 1.65 1.35 3 3 3h5.72l-.5 2H11v2h10v-2h-1.22l-.5-2H25c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3zm-7.28 21h-3.44l.5-2h2.44l.5 2zM25 22H7c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v11H7v2h19c0 .55-.45 1-1 1z'
			></path>
		</svg>
	);
};

export default Monitor;
